import { featureFlagSlugs } from '@/constants/featureFlagSlugs';

export default defineNuxtRouteMiddleware(async () => {
  const useFeatureFlagsStore = useFeatureFlags();

  await useFeatureFlagsStore.fetchFlagByName(featureFlagSlugs.transportLBV2Enclosed);
});
